module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../node_modules/happypack/loader.js?id=jsx!./DailyDetailView.js"));
	}, "DailyDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=DailyDetailView!./src/pages/Learn/Daily/DailyDetail/DailyDetailView.js
// module id = 2225
// module chunks = 367